export function calculateSeason() {
  const hoy = new Date();
  const anyo = hoy.getFullYear();
  const mes = hoy.getMonth();

  // La temporada empieza en septiembre
  if (mes >= 8) {
    return `${anyo}-${anyo + 1}`;
  } else {
    return `${anyo - 1}-${anyo}`;
  }
}

export function getCurrentCustomDate() {
  const now = new Date();
  let d = now.getDate();
  let m = now.getMonth() + 1;
  const y = now.getFullYear();
  return `${d}_${m}_${y}`;
}

// Determina turno según hora actual
export function getCurrentTurno() {
  const hour = new Date().getHours();
  return hour < 15 ? "morning" : "afternoon";
}
